import { Interpolation, Theme, css } from "@emotion/react";
import { HTMLMotionProps, motion } from "framer-motion";

export const Overlay = ({
  ...props
}: any) => {
  const MotionDiv = motion.div as any;

  return (
    <MotionDiv
      css={css`
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.4);
      `}
      {...props}
    />
  );
};
